/* globals Intercom */

var jQuery = require('jquery');
var _ = require('lodash');
var ubBanzai = require('ub/control/banzai-features');
var rxSwitchboard = require('ub/control/rx-switchboard');

//Created via issue LP-7077 and documented at
//builder/notes/lp-7077-auto-layout-to-intercom.org

//The purpose of this file is for it to be used as a way to tie external
//requests via builder events.  For example wanting to trigger a Intercom
//event when the user applies Auto Layout to their page.

;(function(){

  var sendEventToIntercom = function(eventLabel) {
    if (window.Intercom) {
      Intercom('trackEvent', eventLabel);
    }
  };

  //Wait five seconds than open message if available.
  var checkforMessagesAfterDelay = function() {
    if (window.Intercom) {
      setTimeout(function(){
        Intercom('update');
      }, 5000);
    }
  };

  //Auto layout event sends an event to Intercom and after 5 seconds it
  //asks Intercom to open up a message if there is one.
  var autoLayoutEvent = function() {
    jQuery(window).on('autoLayoutComplete', function(e, args){
      sendEventToIntercom('Auto laid out ' + args.ranOn);
      checkforMessagesAfterDelay();
    });
  };

  // Triggered when JS is stripped from text elements
  var strippedScriptsFromText = function() {
    jQuery(window).on('strippedScriptsFromText', function(){
      sendEventToIntercom('Support - Textbox JS Warning');
      checkforMessagesAfterDelay();
    });
  };

  // Listen to copy and paste events and send them to Intercom.
  var copyPasteEvents = function() {
    jQuery(window)
      .on('contentCopied', function() {
        sendEventToIntercom('Copied elements');
        checkforMessagesAfterDelay();
      })
      .on('contentPasted', function(e) {
        var detail;
        if (e.samePage && e.sameSession) {
          detail = 'same page, same tab';
        } else if (e.samePage) {
          detail = 'same page, different tab';
        } else {
          detail = 'different page';
        }
        sendEventToIntercom('Pasted elements (into ' + detail + ')');
        checkforMessagesAfterDelay();
      });
  };

  var externalLightboxSelectedEvents = function() {
    jQuery(window)
      .on('externalLightboxSelected', function() {
        sendEventToIntercom('Selected external lightbox');
        checkforMessagesAfterDelay();
      });
  };

  // Triggered when a user hits our internal lightbox limit
  var hitInternalLightboxLimit = function() {
    jQuery(window).on('hitInternalLightboxLimit', function(){
      sendEventToIntercom('Hit Internal Lightbox Limit: ' + ubBanzai.getFeatureValue('lightboxLimit'));
      checkforMessagesAfterDelay();
    });
  };

  // Triggered when a user creates a lightbox
  var createdInternalLightbox = function() {
    jQuery(window).on('createdInternalLightbox', function(e){
      sendEventToIntercom('Created Internal Lightbox (Using: ' + e.createdUsing + ')');
      sendEventToIntercom('Created Internal Lightbox');
      checkforMessagesAfterDelay();
    });
  };

  var createdVideoBackground = function() {
    rxSwitchboard
      .subjects
      .element_set
      .filter(function(ev) {
        return ev.accessor === 'style.newBackground.type' && ev.value === 'video';
      })
      .ub_subscribe(function() {
        sendEventToIntercom('Created Video Background');
        checkforMessagesAfterDelay();
      });
  };

  var tagUsersForFeatures = function() {
    var LOCAL_STORE_KEY = 'ubIntercomTags';
    var _setCache = function(intercomTags) {
      window.localStorage.setItem(LOCAL_STORE_KEY, JSON.stringify(intercomTags));
    };

    var _getCache = function() {
      return JSON.parse(window.localStorage.getItem(LOCAL_STORE_KEY));
    };

    var intercomTags = _.map(
        _.filter(ubBanzai._getBooleanFeatures(),
          function(def, name) {
            return ubBanzai.isFeatureEnabled(name) &&
              ! _.isUndefined(def.eventTag);
          }),
        function(def) {
          return def.eventTag;
        });

    var nonCachedTags = _.difference(intercomTags, _getCache());

    _.each(nonCachedTags, function(tag) {
      sendEventToIntercom(tag);
    });

    _setCache(intercomTags);
  };

  var sendFeatureGatesToIntercom = function() {
    rxSwitchboard
      .subjects
      .jui_events
      .filter(function(ev) {return ev.type === "pageLoaded";})
      .ub_subscribe(tagUsersForFeatures);
  };

  autoLayoutEvent();
  copyPasteEvents();
  strippedScriptsFromText();
  externalLightboxSelectedEvents();
  hitInternalLightboxLimit();
  createdInternalLightbox();
  createdVideoBackground();

  sendFeatureGatesToIntercom();
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/event_tracking/external_event_tracking.js
// module id = 1075
// module chunks = 0